module.exports = require("./nyn.d.ts");